import MarketingLanding from "../components/marketing/MarketingLanding";
import professionals from "../content/professionals";
import SEO from "../components/SEO";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1550623827-2335c2fdf938?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwcm9wZXJ0eSUyMG1hbmFnZXIlMjB0YWJsZXQlMjBtb2Rlcm58ZW58MHx8fHwxNzc1NTA3Mjg4fDA&ixlib=rb-4.1.0&q=85";

const ProfessionalsPage = ({ locale = "fr" }) => {
  const content = professionals[locale] || professionals.fr;

  return (
    <>
      <SEO page={locale} />
      <MarketingLanding
        content={content}
        heroImage={HERO_IMAGE}
        showLangSwitcher
      />
    </>
  );
};

export default ProfessionalsPage;
